import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c572cd8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "menu" }
const _hoisted_2 = ["onContextmenu"]
const _hoisted_3 = {
  key: 0,
  class: "menuList"
}
const _hoisted_4 = { class: "navigation" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "btns"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["refname"]
const _hoisted_10 = { class: "itemBox" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["src", "alt"]
const _hoisted_13 = {
  key: 1,
  src: "https://infinityicon.infinitynewtab.com/user-share-icon/6e49210c084629259f22609980c48ecf.png",
  alt: "none"
}
const _hoisted_14 = { class: "itemTitle" }
const _hoisted_15 = { class: "itemContent" }
const _hoisted_16 = {
  key: 2,
  class: "btns"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "dialog-footer" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("添加")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("修改")
const _hoisted_24 = { class: "dialog-footer" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("添加")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("修改")

import Footer from "../footer/footer.vue";
import { ArrowUp, ArrowDown, Plus, Close, Edit } from "@element-plus/icons-vue";
import { onMounted } from "@vue/runtime-core";
import { ElIcon, ElTooltip } from "element-plus";
import data from "@/data/data";
import type { FormInstance } from "element-plus";
import { ref } from "vue";
import notify from "@/utils/notify/notify";
import local from "@/utils/localData/local";


export default /*#__PURE__*/_defineComponent({
  __name: 'menu',
  setup(__props) {

onMounted(() => {
    // 撑开底部距离盒子高度计算
    bigBoxHeight();
});

/**
 * 元素节点
 */
let nodes: any = {};

/**
 * 获取 ref 元素
 */
function setRef(item: any) {
    // 如果元素不存在 或 id 与 refname 都不存在的话
    if (!item || !item.attributes.refname.value) {
        return;
    }

    // 添加到元素节点 优先取 id
    nodes[item.attributes.refname.value] = item;
}

/**
 * 跳转到指定链接
 */
function openHref(url: string) {
    window.open(url);
}

/**
 * 滚动到指定位置
 */
function scroll(name: string) {
    // 需要滚动的高度
    let top = 0;

    // 计算滚动高度
    for (const key in nodes) {
        if (key == name) {
            break;
        }
        if (key.includes("list-")) {
            top += nodes[key].clientHeight;
        }
    }

    // 滚动
    nodes.list.scrollTo({
        top,
        behavior: "smooth"
    });
}

/**
 * 撑开底部距离盒子高度计算
 */
function bigBoxHeight() {
    let cache;
    for (const key in nodes) {
        if (key.includes("list-")) {
            cache = nodes[key];
        }
    }

    nodes.bigBox.style.height =
        nodes.list.clientHeight - cache.clientHeight + "px";
}

/**
 * 右键状态
 */
const rightSetting = ref(false);

/**
 * 右键改变状态
 */
function rightClick() {
    rightSetting.value = !rightSetting.value;
}

/**
 * 添加菜单列表 dialog & form & rules & data
 */
const addMenuDialog = ref(false);
const addMenuForm = ref<FormInstance>();
const addMenuRules = ref({
    navName: {
        required: true,
        message: "请填写菜单名字",
        trigger: "blur"
    }
});
const addMenuData = ref({
    navName: ""
});
const updateMenuIndex: any = ref(null);

/**
 * 打开添加菜单
 */
function openAddMenu() {
    addMenuDialog.value = true;
    updateMenuIndex.value = 0;
    addMenuData.value.navName = "";
}

/**
 * 添加菜单
 */
function addMenu(formEl: FormInstance | undefined) {
    if (!formEl) return;
    formEl.validate((valid) => {
        if (!valid) {
            return;
        }
        data.saveData.LinkList.push({
            navName: addMenuData.value.navName,
            links: []
        });
        formEl.resetFields();
        addMenuDialog.value = false;
        local.save();
        notify("添加菜单成功", 1);
        console.log(
            "🚀 菜单链接数据 | file: menu.vue | line 245 | formEl.validate | data.saveData.LinkList",
            data.saveData.LinkList
        );
    });
}

/**
 * 打开修改菜单
 */
function openUpdateMenu(i: any) {
    updateMenuIndex.value = i;
    addMenuDialog.value = true;
    addMenuData.value.navName = data.saveData.LinkList[i].navName;
}

/**
 * 修改菜单列表
 */
function updateMenu(formEl: FormInstance | undefined) {
    if (!formEl) return;
    formEl.validate((valid) => {
        if (!valid) {
            return;
        }
        data.saveData.LinkList[updateMenuIndex.value].navName =
            addMenuData.value.navName;
        updateMenuIndex.value = 0;
        local.save();
        addMenuDialog.value = false;
        notify("修改菜单成功", 1);
        formEl.resetFields();
    });
}

/**
 * 删除菜单
 * @param i index
 */
function removeMenu(i: number) {
    notify(`已删除菜单 “${data.saveData.LinkList[i].navName}”`, 1);
    data.saveData.LinkList.splice(i, 1);
    local.save();
}

/**
 * 添加菜单 dialog & form & rules & data
 */
const addItemDialog = ref(false);
const addItemForm = ref<FormInstance>();
const updateItemIndex = ref<any>({
    i: null,
    i2: null
});
const addItemRules = ref({
    name: {
        required: true,
        message: "请填写网址名字",
        trigger: "blur"
    },
    url: {
        required: true,
        message: "请填写网址",
        trigger: "blur"
    }
});
const addItemData = ref({
    name: "",
    content: "",
    img: "",
    url: ""
});
let addItemIndex = 0;

/**
 * 设置添加网址索引
 */
function setAddItemId(index: any) {
    addItemIndex = index;
    updateItemIndex.value.i = null;
    updateItemIndex.value.i2 = null;
    addItemDialog.value = true;
}

/**
 * 添加网址
 */
function addItem(formEl: FormInstance | undefined) {
    if (!formEl) return;
    formEl.validate((valid) => {
        if (!valid) {
            return;
        }
        data.saveData.LinkList[addItemIndex].links.push(
            JSON.parse(JSON.stringify(addItemData.value))
        );
        addItemDialog.value = false;
        formEl.resetFields();
        local.save();
        notify("添加菜单成功", 1);
        console.log(
            "🚀 菜单链接数据 | file: menu.vue | line 245 | formEl.validate | data.saveData.LinkList",
            data.saveData.LinkList
        );
    });
}

/**
 * 打开修改 item
 */
function openEditItem(i: number, i2: number) {
    updateItemIndex.value.i = i;
    updateItemIndex.value.i2 = i2;

    addItemData.value.name = data.saveData.LinkList[i].links[i2].name;
    addItemData.value.content = data.saveData.LinkList[i].links[i2].content;
    addItemData.value.img = data.saveData.LinkList[i].links[i2].img;
    addItemData.value.url = data.saveData.LinkList[i].links[i2].url;

    addItemDialog.value = true;
}

/**
 * 修改 item
 */
function editItem(formEl: FormInstance | undefined) {
    if (!formEl) return;
    formEl.validate((valid) => {
        if (!valid) {
            return;
        }
        data.saveData.LinkList[updateItemIndex.value.i].links[
            updateItemIndex.value.i2
        ] = JSON.parse(JSON.stringify(addItemData.value));
        addItemDialog.value = false;
        local.save();
        notify("添加链接成功", 1);
        formEl.resetFields();
    });
}

/**
 * 删除 item
 */
function RemoveItem(i: number, i2: number) {
    notify(`已删除菜单 “${data.saveData.LinkList[i].links[i2].name}”`, 1);
    data.saveData.LinkList[i].links.splice(i2, 1);
    local.save();
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["openMenu", { openMenuShow: !_unref(data).openApp }])
      }, [
        (_unref(data).saveData.openAppListShow)
          ? (_openBlock(), _createBlock(_unref(ElIcon), {
              key: 0,
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(data).openApp = true), ["stop"]))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ArrowUp))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(Footer)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["menuBox", {
                menuBoxShow: _unref(data).openApp && _unref(data).saveData.openAppListShow,
                menuBoxBlur: !_unref(data).saveData.AeroState
            }]),
        onContextmenu: _withModifiers(rightClick, ["right","prevent"])
      }, [
        _createVNode(_unref(ElIcon), {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(data).openApp = false))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ArrowDown))
          ]),
          _: 1
        }),
        (_unref(data).saveData.LinkList)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).saveData.LinkList, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    onClick: ($event: any) => (scroll('list-' + item.navName))
                  }, [
                    _createTextVNode(_toDisplayString(item.navName), 1),
                    (rightSetting.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createElementVNode("div", {
                            onClick: _withModifiers(($event: any) => (openUpdateMenu(index)), ["stop"])
                          }, [
                            _createVNode(_unref(Edit))
                          ], 8, _hoisted_7),
                          _createElementVNode("div", {
                            onClick: _withModifiers(($event: any) => (removeMenu(index)), ["stop"])
                          }, [
                            _createVNode(_unref(Close))
                          ], 8, _hoisted_8)
                        ]))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_5))
                }), 128)),
                _createElementVNode("div", {
                  class: "addBtn",
                  onClick: openAddMenu
                }, [
                  _createVNode(_unref(Plus))
                ])
              ]),
              _createElementVNode("div", {
                class: "list",
                refname: "list",
                ref: setRef
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).saveData.LinkList, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    refname: 'list-' + item.navName,
                    ref_for: true,
                    ref: setRef
                  }, [
                    _createElementVNode("h1", null, _toDisplayString(item.navName), 1),
                    _createElementVNode("div", _hoisted_10, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.links, (item2, index2) => {
                        return (_openBlock(), _createBlock(_unref(ElTooltip), {
                          effect: "dark",
                          content: item2.content,
                          placement: "bottom",
                          key: index2
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              onClick: ($event: any) => (openHref(item2.url))
                            }, [
                              (item2.img != '')
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: item2.img,
                                    alt: item2.name
                                  }, null, 8, _hoisted_12))
                                : (_openBlock(), _createElementBlock("img", _hoisted_13)),
                              _createElementVNode("div", null, [
                                _createElementVNode("p", _hoisted_14, _toDisplayString(item2.name), 1),
                                _createElementVNode("p", _hoisted_15, _toDisplayString(item2.content), 1)
                              ]),
                              (rightSetting.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                    _createElementVNode("div", {
                                      onClick: _withModifiers(($event: any) => (
                                                openEditItem(index, index2)
                                            ), ["stop"])
                                    }, [
                                      _createVNode(_unref(Edit))
                                    ], 8, _hoisted_17),
                                    _createElementVNode("div", {
                                      onClick: _withModifiers(($event: any) => (
                                                RemoveItem(index, index2)
                                            ), ["stop"])
                                    }, [
                                      _createVNode(_unref(Close))
                                    ], 8, _hoisted_18)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 8, _hoisted_11)
                          ]),
                          _: 2
                        }, 1032, ["content"]))
                      }), 128)),
                      _createElementVNode("div", {
                        class: "addBtn",
                        onClick: ($event: any) => (setAddItemId(index))
                      }, [
                        _createVNode(_unref(Plus))
                      ], 8, _hoisted_19)
                    ])
                  ], 8, _hoisted_9))
                }), 128)),
                _createElementVNode("div", {
                  refname: "bigBox",
                  ref: setRef
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ], 42, _hoisted_2)
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: addMenuDialog.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((addMenuDialog).value = $event)),
      title: updateMenuIndex.value == 0 ? '添加菜单' : '修改菜单',
      width: "300px"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_20, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (addMenuDialog.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_21
            ]),
            _: 1
          }),
          (updateMenuIndex.value == 0)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "primary",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (addMenu(addMenuForm.value)))
              }, {
                default: _withCtx(() => [
                  _hoisted_22
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                type: "primary",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (updateMenu(addMenuForm.value)))
              }, {
                default: _withCtx(() => [
                  _hoisted_23
                ]),
                _: 1
              }))
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref_key: "addMenuForm",
          ref: addMenuForm,
          model: addMenuData.value,
          rules: addMenuRules.value,
          "label-width": "78px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "菜单名字",
              prop: "navName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: addMenuData.value.navName,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((addMenuData.value.navName) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: addItemDialog.value,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((addItemDialog).value = $event)),
      title: updateItemIndex.value.i == null ? '添加网址' : '修改网址',
      width: "300px"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_24, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (addItemDialog.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_25
            ]),
            _: 1
          }),
          (updateItemIndex.value.i == null)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "primary",
                onClick: _cache[12] || (_cache[12] = ($event: any) => (addItem(addItemForm.value)))
              }, {
                default: _withCtx(() => [
                  _hoisted_26
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                type: "primary",
                onClick: _cache[13] || (_cache[13] = ($event: any) => (editItem(addItemForm.value)))
              }, {
                default: _withCtx(() => [
                  _hoisted_27
                ]),
                _: 1
              }))
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref_key: "addItemForm",
          ref: addItemForm,
          model: addItemData.value,
          rules: addItemRules.value,
          "label-width": "78px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "名字",
              prop: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: addItemData.value.name,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((addItemData.value.name) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "网址",
              prop: "url"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: addItemData.value.url,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((addItemData.value.url) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "介绍",
              prop: "content"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: addItemData.value.content,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((addItemData.value.content) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "图标",
              prop: "img"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: addItemData.value.img,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((addItemData.value.img) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}
}

})